import { axiosBackoffice, axiosPrivate } from '../axiosClient';
import { attachAuthInterceptors } from '../utils/attachAuthInterceptors';
import type { RefreshOutcome } from '../utils/refreshManager';

type InstallGlobalAxiosInterceptorsOptions = {
  getPosAccessToken: () => string | undefined;
  refreshPos: () => Promise<RefreshOutcome>;
  onPosAuthFailure: () => Promise<void> | void;
  getPosHeaders: () => Record<string, string>;
  getBackofficeAccessToken: () => string | undefined;
  refreshBackoffice: () => Promise<RefreshOutcome>;
  onBackofficeAuthFailure: () => Promise<void> | void;
  getBackofficeHeaders: () => Record<string, string>;
};

let teardownInterceptors: (() => void) | null = null;

export function installGlobalAxiosInterceptors(
  options: InstallGlobalAxiosInterceptorsOptions,
) {
  if (teardownInterceptors) return teardownInterceptors;

  const ejectPos = attachAuthInterceptors(axiosPrivate, {
    key: 'pos',
    getAccessToken: options.getPosAccessToken,
    refresh: options.refreshPos,
    onAuthFailure: options.onPosAuthFailure,
    buildHeaders: options.getPosHeaders,
  });

  const ejectBackoffice = attachAuthInterceptors(axiosBackoffice, {
    key: 'backoffice',
    getAccessToken: options.getBackofficeAccessToken,
    refresh: options.refreshBackoffice,
    onAuthFailure: options.onBackofficeAuthFailure,
    buildHeaders: options.getBackofficeHeaders,
  });

  teardownInterceptors = () => {
    ejectPos();
    ejectBackoffice();
    teardownInterceptors = null;
  };

  return teardownInterceptors;
}
